export const getStyles = () => {
    const styles = {
        password: { 
            position: "relative", 
            height: '85px', 
            width: '100%' 
        }
    };
    return styles;
};